// Lib
import { combineReducers } from 'redux';

// Reducers
import settings from './settingsPage/mobileSettingsReducer';
import toolbar from './toolbar/store/mobileToolbarReducer';

export default combineReducers({
    settings,
    toolbar,
});
